const endPoints = {
  LOGIN: "user/sign-in",
  REGISTER: "user/register",
  REQUEST_OTP: "user/request-otp",
  VERIFY_OTP: "user/verify-otp",
  FORGOT_PASSWORD: "user/forgot-password",
  RESET_PASSWORD: "user/reset-password",
  CHANGE_PASSWORD: "user/change-password",
  PROFILE: "user/my-profile",
  UPDATE_PROFILE: "user/update",
  SERVICES: "user/service/",
  SERVICE_BY_SLUG: "user/service-by-name/",
  STYLES: "user/furnishing-styles/",
  CREATE_ORDER: "user/order/",
  ORDERS: "user/my-orders",
  ORDER_DETAILS: "user/order/",
  ORDER_STATUS: "user/order-status/",
  ORDER_REWORK: "user/order-rework/",
  DASHBOARD_ANALYTICS: "user/order-counts",

  UPLOAD_FILE: "/file-upload",
  UPLOAD_FILES: "/upload-files",
  NOTIFICATIONS: "user/notifications",
  UNREAD_NOTIFICATIONS_COUNT: "user/notification-count",
  MARK_NOTIFICATION_AS_READ: "user/notification-read/",
  TERMS_OF_SERVICE: "pages/term_and_condition.html",
  PRIVACY_POLICY: "pages/privacy_policy.html",
  FAQ: "user/faq",
  OUR_WORK: "user/our-works/",
  OUR_WORK_DETAILS: "user/our-work/",

  //Chat Bot Dialog
  // CHAT_BOT: "user/dialog-flow",
  CHAT_BOT: "user/chat-bot",
  STAGE_SMART: "user/stage-smart/generate-image/", // 
  STAGE_SMART_HISTORY: "user/stage-smart/history",
  CREATE_PAYMENT: "user/purchase-queries",
  CREATE_CONTACT: "/user/create-contact",
  CREATE_ENQUIRE: "user/create-enquire",

  FREQUENT_QUESTIONS: "user/faq",
  OUR_CLIENTS: "user/our-clients",
};
export default endPoints;
// unpause 
